export default __webpack_public_path__ + "static/state2-3b484547d30ddcbba10de92752e8a264.jpg";